import React from "react";
import { FiEye, FiEyeOff, FiUser, FiUsers } from "react-icons/fi";

export function RoleBadge({ isElected }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold ${
        isElected
          ? "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300"
          : "border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300"
      }`}
    >
      {isElected ? <FiUsers /> : <FiUser />}
      {isElected ? "Élu(e)" : "Personnel"}
    </span>
  );
}

export function VisibleBadge({ visible }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold ${
        visible
          ? "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300"
          : "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300"
      }`}
    >
      {visible ? <FiEye /> : <FiEyeOff />}
      {visible ? "Visible" : "Masqué"}
    </span>
  );
}